import React from 'react';

interface ILang {
  lang: any;
  changeLanguage: (language: string) => void;
}
export const LanguageContext = React.createContext<ILang | null>(null); //eslint-disable-line
